import { all, call, put, select, takeEvery } from "redux-saga/effects";
import { successAlert, errorAlert } from "../Alerts/actions";
import api from "../../utils/api";
import QueryString from "query-string";
import {
  FETCH_BUNDLES,
  GET_VIEW_DATA,
  ADD_BUNDLES,
  EDIT_BUNDLES,
  DELETE_BUNDLES,
  GET_SUBS,
  ADD_SUB,
} from "./constants";
import {
  fetchBundles as fetchBundlesAction,
  fetchBundlesSuccess,
  fetchBundlesFailure,
  //
  getViewData as getViewDataAction,
  getViewDataSuccess,
  getViewDataFailure,
  //
  addBundleSuccess,
  addBundleFailure,
  //
  editBundleSuccess,
  editBundleFailure,
  //
  deleteBundleSuccess,
  deleteBundleFailure,
  //
  getSubsSuccess,
  getSubsFailure,
  //
  addSubSuccess,
  addSubFailure,
} from "./actions";

export function* fetchBundlesSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/package-item?${query}`);
    yield put(fetchBundlesSuccess(data));
  } catch (e) {
    yield put(fetchBundlesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching news!"));
  }
}

export function* getViewDataSaga({ payload, onGetSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/package-item/${payload}`);
    yield put(getViewDataSuccess(data));
    typeof onGetSuccess == "function" && onGetSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addBundleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/package-item/add`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Bundle added successfully!"));
      yield put(addBundleSuccess());
      if (payload?.history) {
        payload.history.push("/d/bundles");
      }
    }
  } catch (e) {
    yield put(addBundleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while adding bundle!"));
  }
}

export function* editBundleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/package-item/edit/${payload?.data?.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Bundle updated successfully!"));
      yield put(editBundleSuccess());
      yield put(getViewDataAction(payload?.data?.id));
    }
  } catch (e) {
    yield put(editBundleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while updating bundle!"));
  }
}

export function* deleteBundleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/package-item/${payload}`);
    if (data) {
      yield put(successAlert("Bundles deleted successfully!"));
      yield put(deleteBundleSuccess());
      yield put(fetchBundlesAction());
    }
  } catch (e) {
    yield put(deleteBundleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while deleting bundle!"));
  }
}

export function* getSubsSaga({ payload, onGet }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/subscription-list?${query}`,
    );
    yield put(getSubsSuccess(data));
    typeof onGet === "function" && onGet(data);
  } catch (e) {
    yield put(getSubsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching subscription list!"));
  }
}

export function* addSubSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/subscription-item/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Subscription updated successfully!"));
      yield put(addSubSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(addSubFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchBundlesFlow() {
  yield takeEvery(FETCH_BUNDLES, fetchBundlesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addBundleFlow() {
  yield takeEvery(ADD_BUNDLES, addBundleSaga);
}
export function* editBundleFlow() {
  yield takeEvery(EDIT_BUNDLES, editBundleSaga);
}
export function* deleteBundleFlow() {
  yield takeEvery(DELETE_BUNDLES, deleteBundleSaga);
}
export function* getSubsFlow() {
  yield takeEvery(GET_SUBS, getSubsSaga);
}
export function* addSubFlow() {
  yield takeEvery(ADD_SUB, addSubSaga);
}

export default function* BundlesSaga() {
  yield all([
    fetchBundlesFlow(),
    addBundleFlow(),
    editBundleFlow(),
    deleteBundleFlow(),
    getViewDataFlow(),
    getSubsFlow(),
    addSubFlow(),
  ]);
}
